import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FilterGroup, SortOption, FilterResult } from '../../models/filtros.model';

@Component({
  selector: 'app-filtros-genericos',
  templateUrl: './filtros-genericos.component.html',
  styleUrls: ['./filtros-genericos.component.scss'],
  standalone: false,
})
export class FiltrosGenericosComponent implements OnInit {

  @Input() title: string = 'Filtros';
  @Input() subtitle: string = 'Personaliza los resultados';
  @Input() filters: FilterGroup[] = [];
  @Input() sortOptions: SortOption[] = [];
  @Input() currentSortField: string = 'id';
  @Input() currentSortDirection: 'asc' | 'desc' = 'desc';
  @Input() themeColor: 'red' | 'blue' | 'gray' = 'red';
  @Input() showSortDescription: boolean = true;
  @Input() currentViewMode: string = '';

  selectedViewMode: string = '';

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {
    this.selectedViewMode = this.currentViewMode;
  }

  setViewMode(mode: string) {
    this.selectedViewMode = mode;
  }

  toggleOption(group: FilterGroup, value: any) {
    if (group.id !== 'especiales' && this.hasEspecialesActive()) {
      return;
    }

    if (group.isSingleSelect) {
      group.selectedValues = [value];
      return;
    }

    const index = group.selectedValues.indexOf(value);
    if (index > -1) {
      group.selectedValues.splice(index, 1);
    } else {
      group.selectedValues.push(value);
    }
  }

  /**
   * Filtros regulares que se renderizan como cards independientes (excluyendo subgrupos de agrupación si existe 'agrupacion')
   */
  get regularFilters(): FilterGroup[] {
    const hasAgrupacion = this.filters.some(g => g.id === 'agrupacion');
    if (!hasAgrupacion) return this.filters;
    return this.filters.filter(g => g.id !== 'formatos' && g.id !== 'regiones');
  }

  /**
   * Subgrupos pertinentes (formatos / regiones) para renderizar dentro del mismo card de agrupación
   */
  get subAgrupacionGroups(): FilterGroup[] {
    const agrpGroup = this.filters.find(g => g.id === 'agrupacion');
    if (!agrpGroup || !agrpGroup.selectedValues?.length) return [];
    
    const modo = agrpGroup.selectedValues[0];
    const subGroups: FilterGroup[] = [];

    if (modo === 'formato' || modo === 'ninguno') {
      const fmt = this.filters.find(g => g.id === 'formatos');
      if (fmt) subGroups.push(fmt);
    }
    if (modo === 'region' || modo === 'ninguno') {
      const reg = this.filters.find(g => g.id === 'regiones');
      if (reg) subGroups.push(reg);
    }
    return subGroups;
  }

  isGroupVisible(group: FilterGroup): boolean {
    const agrpGroup = this.filters.find(g => g.id === 'agrupacion');
    if (!agrpGroup || !agrpGroup.selectedValues?.length) {
      return true;
    }
    const modo = agrpGroup.selectedValues[0];
    if (modo === 'formato' && group.id === 'regiones') {
      return false;
    }
    if (modo === 'region' && group.id === 'formatos') {
      return false;
    }
    return true;
  }

  hasEspecialesActive(): boolean {
    const especialesGroup = this.filters.find(g => g.id === 'especiales');
    return !!(especialesGroup && especialesGroup.selectedValues.length > 0);
  }

  setSort(field: string) {
    if (this.currentSortField === field) {
      this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSortField = field;
      this.currentSortDirection = field === 'id' ? 'desc' : 'asc';
    }
  }

  clearFilters() {
    this.filters.forEach(group => {
      if (group.id === 'estados') {
        group.selectedValues = group.options.map(opt => opt.value);
      } else {
        group.selectedValues = [];
      }
    });
  }

  clearSection(group: FilterGroup) {
    group.selectedValues = [];
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  apply() {
    const result: FilterResult & { viewMode?: string } = {
      filters: this.filters,
      sortField: this.currentSortField,
      sortDirection: this.currentSortDirection,
      viewMode: this.selectedViewMode
    };
    this.modalCtrl.dismiss(result);
  }

}
